<vl-header-dialog (close)="close.emit()" [rightElement]="exportBtn">
  <ng-content></ng-content>
</vl-header-dialog>

<ng-template #exportBtn>
  <vl-excel-export-button
    size="medium"
    [loading]="exporting()"
    [disabled]="exporting()"
    [tooltip]="exportTooltipKey() | trans"
    (action)="export.emit()"/>
</ng-template>
